<template>
  <div
    :class="[
      selected ? 'border-primary' : 'border-strokeDefault',
      { loading: option.loading, 'cursor-pointer': !option.loading },
      'summary-option-card w-100 h-100 pa-4 rounded-lg',
      'd-flex flex-column justify-space-between',
      'bg-bgDefault border border-opacity-100',
    ]"
    :role="option.loading ? undefined : 'button'"
    :tabindex="option.loading ? -1 : 0"
    @click="select"
    @keydown.enter.self.prevent="select"
    @keydown.space.self.prevent="select"
  >
    <div class="d-flex flex-column ga-3">
      <div class="d-flex align-center ga-2">
        <div class="text-h2 text-textDarkest flex-grow-1">
          {{ title }}
        </div>
        <div
          v-if="subtitle"
          class="text-body-3 text-navy700 text-right"
        >
          {{ subtitle }}
        </div>
      </div>

      <div
        v-if="option.loading"
        class="d-flex flex-column ga-2"
      >
        <div
          v-for="line in SKELETON_LINES"
          :key="line"
          class="skeleton-line rounded-pill w-100"
          :class="skeletonColor"
        />
      </div>

      <div
        v-else-if="option.error === 'no_match'"
        class="text-body-2 text-textError"
      >
        No matching job post found for this role.
      </div>

      <div
        v-else-if="option.error"
        class="d-flex align-center ga-2"
      >
        <span class="text-body-2 text-textError">
          JobNav ran into a problem generating this summary.
        </span>
        <v-btn
          variant="text"
          size="small"
          prepend-icon="mdi-refresh"
          class="text-button-3 text-textDarkest ml-auto"
          @click.stop="emit('retry')"
        >
          Try again
        </v-btn>
      </div>

      <div
        v-else-if="option.summary"
        class="summary-text text-body-2"
        :class="selected ? 'text-textDarkest' : 'text-textDark'"
      >
        <DpplSafeHtml
          :html="option.summary"
        />
      </div>
    </div>

    <div
      :class="{ 'opacity-0 pointer-events-none': !(selected && option.summary && !option.loading) }"
      class="d-flex align-center ga-3 mt-4"
    >
      <v-btn
        variant="outlined"
        rounded="lg"
        height="32"
        width="130"
        class="text-button-3 text-textDarkest bg-bgDefault border-strokeDefault"
        @click.stop="emit('append')"
      >
        Add to Summary
      </v-btn>
      <v-btn
        variant="flat"
        color="primary"
        rounded="lg"
        height="32"
        class="text-button-3"
        @click.stop="emit('replace')"
      >
        Replace Summary
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

const SKELETON_LINES = 9;

const props = defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  option: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});

const emit = defineEmits(['select', 'append', 'replace', 'retry']);

const skeletonColor = computed(() => (props.selected ? 'bg-grey500' : 'bg-strokeDefault'));

const select = () => {
  if (!props.option.loading) emit('select');
};
</script>

<style scoped lang="less">
.summary-option-card {
  &:hover {
    --v-border-color: var(--v-theme-brandPrimary);
    .summary-text {
      color: rgb(var(--v-theme-textDarkest)) !important;
    }
  }
}

.skeleton-line {
  height: 13px;
}
</style>
